import * as React from "react";
import {SysOptionEnum} from "../models/sys/sys-option";
import RootStore from "../stores/root-store";

export interface IBaseProps {
    rootStore?: RootStore;
}

class Base<T extends IBaseProps, S = {}> extends React.Component<T, S> {
    protected rootStore: RootStore | undefined;

    constructor(props: T) {
        super(props);
        this.rootStore = props.rootStore;
    }

    public componentDidMount(): void {
        const rootStore = this.rootStore;

        if (rootStore) {
            rootStore.sysStore.getOptions();
            rootStore.translationStore.applyTranslations();
        }
    }

    protected isOrdersAllowed(): boolean {
        const option = this.getOption(SysOptionEnum.OrdersAllowed);
        return option === "true";
    }

    protected getOption(name: SysOptionEnum): string {
        return this.rootStore.sysStore.getOptionByName(name);
    }

    protected translate(key: string, defaultValue: string, replacedValue?: any): string {
        return this.rootStore.translationStore.translate(key, defaultValue, replacedValue);
    }
}

export default Base;



// WEBPACK FOOTER //
// ./src/components/base.ts